export default "__VITE_ASSET__BmRzHsyM__"